import * as _ from 'lodash';
import { RollbarMessages } from '../../../../ng2/shared/constants/rollbar-messages.constant';

angular.module('nv.shared.error-handling').factory('ErrorModal', function($mdDialog, Rollbar) {
  let ErrorModal: any = {};
  let sendToRollbar = true;
  let requireRefresh = false;

  /**
   * Show the error modal
   *
   * @param title {string} Title for the modal (optional)
   * @param error {*} The error. This class tries to be as versatile as possible, so this can be many different
   *    things:
   *       - A Javascript Error instance, or a instance of a subclass of Error
   *       - A $http, $resource, or NvBaseModel `response` object from the `.catch(function(response))` callback
   *       - Any POJO with a `message` property
   */
  ErrorModal.show = function() {
    let title = 'An error occurred';
    let error;

    if (arguments.length === 2) {
      title = arguments[0];
      error = arguments[1];
    } else if (arguments.length === 1) {
      error = arguments[0];
    } else {
      throw new Error('ErrorModal.show() needs 1 or 2 arguments');
    }

    let message = '';
    let details;

    if (!error) {
      // TODO: It seems that sometimes we get here with error === undefined
      // Most likely this is because another modal has a .catch(err => ErrorModal.show(err)) call
      // but err is undefined if user clicks cancel button (JC).
      // For now, return with void;
      Rollbar.debug(new Error('Error modal called, but no error provided'), { title, error });
      return;
    }

    if (_.isError(error)) {
      message = error.message;
      details = 'Error type: ' + error.name;
    } else if (error.status && error.statusText) {
      // is a $http response
      if (error.data && error.data.message) {
        // has a nice message from our API in the response body, so use that
        // check first to see if the api is returning a custom userMessage from nv-student-api
        message = error.data.userMessage || error.data.message;
      } else {
        message = 'Server error: ' + error.statusText;
      }

      details = error.status.toString() + ' ' + error.statusText + '\n';
    } else if (error.message) {
      // POJO
      message = error.message;
      details = error.details;
    } else if (error.data && error.data.message) {
      // check first to see if the api is returning a custom userMessage from nv-student-api
      message = error.data.userMessage || error.data.message;
    } else {
      message = 'Unknown error';
      details = JSON.stringify(error, null, 2);
      if (details.length > 500) {
        details = details.substring(0, 500) + '...';
      }
    }

    if (!details && error.stack) {
      details = error.stack;
    }

    const errorMessage = { title, message, details };

    // ErrorModal is called with errors which in some cases, are not bugs.
    // Prevent those from being categorized as errors.

    // check known warnings to see if message is a full or partial match.
    const messageIsWarning = _.some(RollbarMessages.WARNINGS, (warningMessage: string) => {
      return errorMessage.message.indexOf(warningMessage) > -1;
    });

    const messageIsInfo = _.some(RollbarMessages.INFO, (warningMessage: string) => {
      return errorMessage.message.indexOf(warningMessage) > -1;
    });

    if (sendToRollbar) {
      if (messageIsWarning) Rollbar.warning(`Warning: ${JSON.stringify(errorMessage)}`, error);
      else if (messageIsInfo) Rollbar.info(error);
      else Rollbar.error(`Error: ${JSON.stringify(errorMessage)}`, error);
    }

    // TODO: temporary fix to not show ErrorModal on 401 errors
    if (_.includes(errorMessage.details, '401')) {
      return Promise.resolve(null);
    }

    return $mdDialog.show({
      template: require('./error-modal.html'),
      parent: angular.element(document.body),
      locals: errorMessage,
      controller(title, message, details, $scope, $mdDialog, $window) {
        $scope.title = title;
        $scope.message = message;
        $scope.details = details;
        $scope.showDetails = false;
        $scope.requireRefresh = requireRefresh;

        if ($scope.requireRefresh) {
          $scope.message += '\n\nPlease refresh the page to see the most up-to-date data.';
        }

        $scope.gotIt = function() {
          $mdDialog.hide();
        };
        $scope.showHideDetails = function() {
          $scope.showDetails = !$scope.showDetails;
        };
        $scope.refreshPage = () => $window.location.reload();
      },
    });
  };

  ErrorModal.showAndRequireRefresh = function(...args) {
    requireRefresh = true;
    ErrorModal.show(...args);
  };

  ErrorModal.showAndRequireRefreshNoRollbar = function(...args) {
    requireRefresh = true;
    sendToRollbar = false;
    ErrorModal.show(...args);
  };

  ErrorModal.showNoRollbar = function(...args) {
    sendToRollbar = false;
    ErrorModal.show(...args);
  };

  return ErrorModal;
});
